import { render, staticRenderFns } from "./schedule_match_list.vue?vue&type=template&id=40193e4a&scoped=true"
import script from "./schedule_match_list.vue?vue&type=script&lang=js"
export * from "./schedule_match_list.vue?vue&type=script&lang=js"
import style0 from "./schedule_match_list.vue?vue&type=style&index=0&id=40193e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40193e4a",
  null
  
)

export default component.exports